// extracted by mini-css-extract-plugin
export default {"root":"NotFoundTitle_root__yiC2v","label":"NotFoundTitle_label__gWeZj","description":"NotFoundTitle_description__74RuF","title":"NotFoundTitle_title__akByc"};